import React, { PureComponent } from 'react';
import './soldierDetail.css'
import Http from '../../networkReq/http';
import Request from '../../networkReq/request';
import { Link } from "react-router-dom";
import { showhtml } from "utils/methods";
import NoDataPicture from 'components/NoDataPicture'

export default class SoliderDetail extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      info: {},
      time: "",
      attachment: [],
      beforeArticle: "",
      nextArticle: ""
    };
  }
  componentDidMount = () => {

    const { location: { search } } = this.props;
    let id = search.substring(1);
    this.getDetail(id)

  }

  getDetail(id) {
    Http.get(Request.articleDetail(), { id }, obj => {
      if (obj && obj.code == 200) {
        let { data } = obj;
        let timeCreate = data.article.createTime.split(" ")[0];
        this.setState(
          {
            info: data.article,
            attachment: data.annex,
            beforeArticle: data.beforeArticle,
            nextArticle: data.nextArticle,
            time: timeCreate
          },
          () => { }
        );
      }
    });
  }

  goDetail(id, e) {
    e.preventDefault();
    this.props.history.replace("/entrance/soldierDetail?" + id);
    window.location.reload()

  }

  render() {
    const { info, pre, link, time, nextArticle, beforeArticle } = this.state
    return (
      <div className="soldier_detail">
        <div className="soldier_detail_title">{info.title}</div>
        <div className="soldier_detail_tooltip">
          <span>信息来源：</span><span style={{marginRight: "40px"}}>{info.fromurl}</span>
          <span>发布日期：</span><span>{time}</span>
        </div>
        <div className="soldier_detail_content">
          <div style={{ marginBottom: '30px', borderBottom: '1px solid #DCDFDE' }}>
            {showhtml(info.content)}
            {/* 图片重复 */}
            {/* <div className="soldier_detail_content_img">
              {
                info.image == '' ? <NoDataPicture /> :
                <img src={info.image} />
              }
            </div> */}
          </div>

          <div className="soldier_detail_content_skip flip">
            <div>
              上一篇：
                          {beforeArticle != "" ? (
                <a onClick={this.goDetail.bind(this, beforeArticle.id)}>
                  {beforeArticle.title}
                </a>
              ) : (
                  <span>没有文章了</span>
                )}{" "}
            </div>
            <div>
              下一篇：
                          {nextArticle != "" ? (
                <a onClick={this.goDetail.bind(this, nextArticle.id)}>
                  {nextArticle.title}
                </a>
              ) : (
                  <span>没有文章了</span>
                )}
            </div>
          </div>

        </div>
      </div>
    )
  }
}